
import { useState, useMemo } from 'react';
import { User } from '@/types/user';

export function useUsersFilter(users: User[]) {
  const [searchQuery, setSearchQuery] = useState('');
  const [roleFilter, setRoleFilter] = useState('all');
  const [statusFilter, setStatusFilter] = useState('all');

  const filteredUsers = useMemo(() => {
    return users.filter(user => {
      // Apply search filter
      const matchesSearch = searchQuery.trim() === '' || 
        user.name.toLowerCase().includes(searchQuery.toLowerCase()) || 
        user.email.toLowerCase().includes(searchQuery.toLowerCase());
      
      // Apply role filter
      const matchesRole = roleFilter === 'all' || user.role.toLowerCase() === roleFilter;
      
      // Apply status filter
      const matchesStatus = statusFilter === 'all' || user.status === statusFilter;
      
      console.log(`User: ${user.email}, Role: ${user.role}, Status: ${user.status}, Invitation: ${user.invitationStatus}`);
      console.log(`Filters - Search: ${matchesSearch}, Role: ${matchesRole}, Status: ${matchesStatus}`);
      console.log(`Role filter: ${roleFilter}, Status filter: ${statusFilter}`);
      
      // Item passes filter if it matches all conditions
      const passes = matchesSearch && matchesRole && matchesStatus;
      console.log(`User ${user.email} passes filter: ${passes}`);
      
      return passes;
    });
  }, [users, searchQuery, roleFilter, statusFilter]);

  return {
    searchQuery,
    setSearchQuery,
    roleFilter,
    setRoleFilter,
    statusFilter,
    setStatusFilter,
    filteredUsers
  };
}
